var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.retailListComponent,{tag:"component",attrs:{"active-item":_vm.vuexSelectedRetail,"list-data":_vm.vuexRetailListData}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfb7324e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/expertoRetail/components/GeneralKeyKpiAnalysis/RetailListSelector.vue
// module id = 1089
// module chunks = 89